import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import {HashRouter as Router, Route, Switch} from 'react-router-dom';
import App from './App.js';
import { AirbrakeErrorBoundary } from './Airbrake';
import registerServiceWorker from './registerServiceWorker';
import './assets/sass/light-bootstrap-dashboard.scss';
import './assets/css/demo.css';
import './assets/css/pe-icon-7-stroke.css';
import './config';
import {addLocaleData, IntlProvider} from "react-intl";
import en from "react-intl/locale-data/en";
import cy from "react-intl/locale-data/cy";
// Import the translations for all languages
import allLanguages from "./locales/all.json";
import i18n from "./main/i18n";

// Import the locale data (currency symbols, decimal separator, etc.) for all the countries of interest
addLocaleData([...en, ...cy]);

// Try full locale, try locale without region code, fallback to 'en'
const localMessages = allLanguages[i18n.LANG];

ReactDOM.render((
  <AirbrakeErrorBoundary>
    <IntlProvider locale={i18n.LANG} messages={localMessages}>
      <Router>
        <Switch>
          <Route component={App}/>
        </Switch>
      </Router>
    </IntlProvider>
  </AirbrakeErrorBoundary>
), document.getElementById('root'));

/**
 * Allow app to be accessible offline
 */
registerServiceWorker();
